/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ materialName: NonNullable<unknown>, requiredQty: NonNullable<unknown>, availableQty: NonNullable<unknown> }} Error_Packaging_Count_Log_Insufficient_LotInputs */

const vi_error_packaging_count_log_insufficient_lot = /** @type {(inputs: Error_Packaging_Count_Log_Insufficient_LotInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Kho không đủ ${i?.materialName} để lập phiếu xuất: cần xuất ${i?.requiredQty} nhưng các lô chỉ còn ${i?.availableQty}. Kiểm lại ba số đã đếm, hoặc nhập lô vật tư vào kho rồi lưu lại mẻ.`)
};

/**

* @param {Error_Packaging_Count_Log_Insufficient_LotInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_packaging_count_log_insufficient_lot = /** @type {((inputs: Error_Packaging_Count_Log_Insufficient_LotInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Packaging_Count_Log_Insufficient_LotInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_packaging_count_log_insufficient_lot(inputs)
});